import { useEmployee } from '@/modules/tenant/hooks/useTenantAuth';

/**
 * #1400 — whether the current employee may use AI Reporting, read from the
 * server-derived `can_use_reporting` flag on the auth payload (`/auth/me` and the
 * bootstrap island): the reporting module is on and the employee can see at least
 * one field of an enabled catalog pack (inventory, sales, CRM, service, customers
 * or finance). Never guess this from a permission name.
 *
 * UX gate only (nav entry, `/reporting` route, dashboard pins); every Reporting
 * endpoint re-checks it. An absent flag (no employee, or an older cached auth
 * payload) reads as `false`, like `useCan()`.
 */
export function useCanUseReporting(): boolean {
  return useEmployee()?.can_use_reporting === true;
}
